import { Injectable } from '@angular/core'
import { EstimateTemplateModel, RestService } from '@mmx/shared'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class EstimateTemplateLoaderService {
  constructor(private readonly restService: RestService) {}

  loadTemplate(templateId: string): Observable<EstimateTemplateModel> {
    const route = `/crud/estimate-templates/${encodeURIComponent(templateId)}`
    return this.restService
      .get<EstimateTemplateModel>(route)
      .pipe(map(response => new EstimateTemplateModel(response.data)))
  }
}
